import { useState } from 'react'
import Layout from '../components/Layouts/AdminLayout'
import HeaderContainer from '../containers/Header/Header.container'
import SidebarContainer from '../containers/Sidebar/Sidebar.container'
import PensionLogsListContainer from '../containers/PensionLogs/PensionLogs.container'
import {
  SegmentButton,
  Segmented,
  TabHint,
  Toolbar,
  ToolbarLeft,
} from './PensionLog.styles'

const LOG_CONTEXTS = [
  {
    key: 'SCRAPER',
    label: 'Scraper',
    hint: 'UTM scrape: month, duration, values, errors.',
  },
  {
    key: 'SENDER',
    label: 'Sender',
    hint: 'Notifications: user, pension, UTM, subject, errors.',
  },
]

const PensionLogs = () => {
  const [activeTab, setActiveTab] = useState(LOG_CONTEXTS[0].key)
  const active = LOG_CONTEXTS.find((c) => c.key === activeTab) || LOG_CONTEXTS[0]

  return (
    <Layout
      header={<HeaderContainer />}
      sidebar={<SidebarContainer />}
      title="Logs"
      description="Consola de procesos Scraper y Sender."
    >
      <Toolbar>
        <ToolbarLeft>
          <Segmented role="tablist" aria-label="Contexto de logs">
            {LOG_CONTEXTS.map(({ key, label }) => (
              <SegmentButton
                key={key}
                type="button"
                role="tab"
                aria-selected={activeTab === key}
                $active={activeTab === key}
                onClick={() => setActiveTab(key)}
              >
                {label}
              </SegmentButton>
            ))}
          </Segmented>
        </ToolbarLeft>
      </Toolbar>
      <TabHint>{active.hint}</TabHint>
      <PensionLogsListContainer context={activeTab} />
    </Layout>
  )
}

export default PensionLogs
